import Vue from 'vue';
import App from './App.vue';
import router from '@/router';
import store from '@/store';
import { UserProfile } from '@/models/user-profile';
import { UserModule } from '@/store/modules/user';
import './registerServiceWorker';

import * as fb from './firebase';

import './assets/scss/app.scss';

import '@/assets/scss/webflow.css';
import '@/assets/scss/normalize.css';
import '@/assets/scss/mixlet.webflow.css';
import '@/assets/scss/fixes.css';

Vue.config.productionTip = false;

import SimpleAnalytics from 'simple-analytics-vue';
Vue.use(SimpleAnalytics, { skip: process.env.NODE_ENV !== 'production' });

import VeeValidate from 'vee-validate';
Vue.use(VeeValidate);

import VueGlide from 'vue-glide-js';
import 'vue-glide-js/dist/vue-glide.css';
Vue.use(VueGlide);

import * as VueGoogleMaps from 'vue2-google-maps';
import { GOOGLE_MAPS_API_KEY } from '@/secrets';
Vue.use(VueGoogleMaps, {
  load: {
    key: GOOGLE_MAPS_API_KEY
  }
});

// Global
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';
Vue.component(VueCropper);

import VModal from 'vue-js-modal';
Vue.use(VModal, { dynamic: true, injectModalsContainer: true });

import VueHead from 'vue-head';
Vue.use(VueHead);

import 'lazysizes';

import imgixTransformer from '@sparwelt/vue-imgix-transformer';
Vue.use(imgixTransformer, {
  imgixCdnConfigs: { myConfig1: {
    cdnOptions: {
      domain: 'mixlet-dev.imgix.net'
    },
    sourceDomain: 'https://storage.googleapis.com/mixlet.appspot.com/'
  },
  myConfig2: {
    cdnOptions: {
      domain: 'mixlet-dev.imgix.net'
    },
    sourceDomain: 'https://firebasestorage.googleapis.com/v0/b/mixlet.appspot.com/o/'
  },

},
  // imgixImageConfigs: myImageConfigs
  imgixModule: require('imgix-core-js')
  // Optionally you can pass the imgix-core-js module instead of our minimal functionalities
});


let app: Vue;

import { ListSaveActions } from '@/actions/list-save-actions';
import { UserFollowActions } from '@/actions/user-follow-actions';
import { ItemStarActions } from '@/actions/item-star-actions';
import { UserProfileUtil } from '@/model-utils/user-profile-util';


import queryString from 'query-string';

function makeApp() {
  if (!app) {
    app = new Vue({
      router,
      store,
      render: (h) => h(App)
    }).$mount('#app');
  }
}

function setProfileAndInitApp(userProfile: UserProfile) {
  store.watch(
    (state, getters) => state.user.userProfile,
    () => {
      makeApp();
    }
  );

  UserModule.setUserProfile(userProfile);

  ListSaveActions.watchSavedListIdsForUser(userProfile.id, (savedListIds) => {
    UserModule.setSavedListIds(savedListIds);
  });
  ItemStarActions.watchStarredItemIdsForUser(userProfile.id, (starredItemIds) => {
    UserModule.setStarredItemIds(starredItemIds);
  });
  UserFollowActions.watchFollowedUserIdsForUser(userProfile.id, (followedUserIds) => {
    UserModule.setFollowedUserIds(followedUserIds);
  });
}

function loadProfileAndInitApp(uid: string) {
  fb.usersCollection.doc(uid).onSnapshot((res) => {
    if (res.exists) {
      setProfileAndInitApp(
        UserProfile.fromFirebaseDoc(res.id, res.data())
      );
    } else {
      makeApp();
    }
  },
    (error) => {console.error('error in load profile', error);}
  );
}

async function loadAppFromUser(user: any) {
  const parsedQuery = queryString.parse(window.location.search);
  if (parsedQuery.escalate) {
    console.log('trying to escalate');
    const originalUser = await UserProfileUtil.fetchProfileById(user.uid);
    if (originalUser.isAdmin) {
      const otherProfile = await UserProfileUtil.fetchProfileByUsername(parsedQuery.escalate as string).then();
      setProfileAndInitApp(otherProfile);
    } else {
      throw new Error('naughty naughty');
    }
  } else {
    loadProfileAndInitApp(user.uid);
  }
}

fb.auth.onAuthStateChanged((user) => {
  if (user) {
    loadAppFromUser(user);
  } else {
    makeApp();
  }
});
